import Row from "react-bootstrap/Row";
import HeaderContainer from "../../components/ContainerComponents/HeaderContainer";
import MainContainer from "../../components/ContainerComponents/MainContainer";
import PositionLevelTable from "./PositionLevelTable";

const PositionLevels = () => {
    return (
        <MainContainer>
            <HeaderContainer title={"Befattningsnivåer"}/>
            <Row>
                <PositionLevelTable/>
            </Row>
        </MainContainer>
    );
};

export default PositionLevels;